<template>
    <i class="fa-star mr-2 text-warning cursor-pointer"
       :class="featuredClass"
       @click="toggleFeatured"/>
</template>

<script>
    import GeneralMixins from "../../mixins/GeneralMixins";

    export default {
      props: ['featured', 'url', 'itemType'],

      mixins: [GeneralMixins],

      data: function() {
        return {
          featuredValue: this.featured === 'true'
        }
      },

      methods: {
        toggleFeatured: function() {
          this.$http.patch(this.url, {
            [this.itemType]: {
              featured: !this.featuredValue
            }
          }).then(fulfilled => {
            this.featuredValue = !this.featuredValue
          }, rejected => {
            this.showErrorToast("There was an error while making this asset featured")
          })
        }
      },

      computed: {
        featuredClass: function() {
          return this.featuredValue ? 'fas' : 'far';
        }
      }
    }
</script>